import SiteHeader from "./SiteHeader";
import "../styles/components/AwardsPage.css";

const galaDetails = [
  "Tuesday, March 11, 2026",
  "6:00 PM – 10:00 PM",
  "Grand Ballroom, The Ritz-Carlton, Chicago",
];

const awardSections = [
  {
    title: "President's Award – MVP Market",
    subtitle: "Recognizing outstanding craftsmanship and dedication to excellence",
    nominees: [
      {
        name: "Jane Doe",
        role: "Regional Sales Director",
        company: "Premium Spirits Distribution",
        description: "Exceptional performance in driving market growth and brand excellence",
      },
      {
        name: "John Doe",
        role: "Market Development Manager",
        company: "Luxury Beverage Group",
        description: "Outstanding leadership in expanding premium brand presence",
      },
      {
        name: "Sarah Mitchell",
        role: "Territory Manager",
        company: "Elite Distribution Partners",
        description: "Remarkable achievement in building lasting client relationships",
      },
    ],
  },
  {
    title: "On Premise Market of the Year",
    subtitle: "Celebrating excellence in on-premise market development",
    nominees: [
      {
        name: "Michael Chen",
        role: "On-Premise Sales Director",
        company: "Metropolitan Distributors",
        description: "Pioneering innovative partnerships with premium establishments",
      },
      {
        name: "Emily Rodriguez",
        role: "Hospitality Account Executive",
        company: "Prestige Beverage Solutions",
        description: "Exceptional growth in luxury hotel and restaurant placements",
      },
      {
        name: "David Thompson",
        role: "On-Premise Specialist",
        company: "Premium Brands Collective",
        description: "Strategic expansion into high-end venue partnerships",
      },
    ],
  },
  {
    title: "Leadership in Excellence",
    subtitle: "Honoring exceptional leadership driving organizational success",
    nominees: [
      {
        name: "Lisa Anderson",
        role: "Vice President of Sales",
        company: "National Distribution Network",
        description: "Transformational leadership resulting in record-breaking performance",
      },
      {
        name: "James Wilson",
        role: "Regional Director",
        company: "Luxury Portfolio Group",
        description: "Inspiring team excellence and fostering culture of achievement",
      },
      {
        name: "Maria Garcia",
        role: "Division Manager",
        company: "Premier Spirits Company",
        description: "Strategic vision driving market expansion and team development",
      },
    ],
  },
  {
    title: "Spirit of Conquest",
    subtitle: "Recognizing bold initiative and pioneering market achievements",
    nominees: [
      {
        name: "Robert Kim",
        role: "Business Development Director",
        company: "Emerging Markets Division",
        description: "Breakthrough success in establishing new market territories",
      },
      {
        name: "Jennifer Brown",
        role: "Strategic Accounts Manager",
        company: "Growth Markets Group",
        description: "Innovative approach to conquering competitive market challenges",
      },
      {
        name: "Carlos Martinez",
        role: "Market Expansion Lead",
        company: "Frontier Distribution",
        description: "Exemplary courage in pursuing and winning key accounts",
      },
    ],
  },
  {
    title: "Turn Around of the Year",
    subtitle: "Celebrating remarkable transformation and recovery achievements",
    nominees: [
      {
        name: "Alex Turner",
        role: "Territory Recovery Specialist",
        company: "Revitalization Partners",
        description: "Outstanding success in transforming underperforming territory",
      },
      {
        name: "Sophia Lee",
        role: "Market Restoration Manager",
        company: "Strategic Renewal Group",
        description: "Exceptional turnaround of challenging market conditions",
      },
      {
        name: "Nathan Parker",
        role: "Regional Transformation Lead",
        company: "Performance Excellence Division",
        description: "Remarkable achievement in reversing declining market trends",
      },
    ],
  },
  {
    title: "Retail Theater",
    subtitle: "Honoring creativity and innovation in retail experiences",
    nominees: [
      {
        name: "Olivia Martin",
        role: "Retail Experience Director",
        company: "Luxury Retail Innovations",
        description: "Creating unforgettable brand experiences through theatrical retail",
      },
      {
        name: "Daniel Foster",
        role: "Visual Merchandising Manager",
        company: "Premium Display Group",
        description: "Pioneering immersive retail presentations driving consumer engagement",
      },
      {
        name: "Rachel Singh",
        role: "Brand Activation Specialist",
        company: "Experiential Marketing Solutions",
        description: "Innovative retail theater concepts elevating brand storytelling",
      },
    ],
  },
];

export default function AwardsPage() {
  return (
    <div className="awards">
      <SiteHeader />

      <main className="awards__main">
        <section className="awards__hero">
          <div className="container awards__heroInner">
            <div className="awards__heroKicker">
              2026 MOËT HENNESSY
              <br />
              DISTRIBUTOR CONFERENCE
            </div>
            <h1 className="awards__heroTitle">Awards</h1>
            <div className="awards__heroSub">Future Forward</div>
          </div>
        </section>

        <section className="awards__intro">
          <div className="container awards__introInner">
            <p className="awards__introText">
              Celebrating excellence and groundbreaking achievements in innovation across industries.
            </p>
          </div>
        </section>

        <section className="awards__gala">
          <div className="container awards__galaInner">
            <div className="awards__sectionBar">Awards Gala Dinner</div>
            <div className="awards__galaCard">
              <div className="awards__galaImage" aria-hidden="true">
                Image Placeholder
              </div>
              <div className="awards__galaContent">
                <div className="awards__galaDetails">
                  {galaDetails.map((detail) => (
                    <div key={detail}>{detail}</div>
                  ))}
                </div>
                <p className="awards__galaCopy">
                  Join us for an elegant evening of recognition, networking, and celebration.
                  Formal attire recommended.
                </p>
                <div className="awards__galaNote">*Included with your conference registration</div>
              </div>
            </div>
          </div>
        </section>

        <section className="awards__sections">
          <div className="container awards__sectionsInner">
            {awardSections.map((section) => (
              <div className="awards__sectionCard" key={section.title}>
                <div className="awards__sectionHeading">
                  <h2 className="awards__sectionTitle">{section.title}</h2>
                  <p className="awards__sectionSubtitle">{section.subtitle}</p>
                </div>
                <div className="awards__nomineesBar">Nominees</div>
                <div className="awards__nomineesGrid">
                  {section.nominees.map((nominee) => (
                    <div className="awards__nominee" key={nominee.name}>
                      <div className="awards__nomineeName">{nominee.name}</div>
                      <div className="awards__nomineeRole">{nominee.role}</div>
                      <div className="awards__nomineeCompany">{nominee.company}</div>
                      <div className="awards__nomineeDesc">{nominee.description}</div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}
